const small = {
  spacing1: 2,
  spacing2: 4,
  spacing3: 8
};

const medium = {
  spacing1: 16,
  spacing2: 24,
  spacing3: 32,
  spacing4: 40,
  spacing5: 48
};

const large = {
  spacing1: 56,
  spacing2: 64,
  spacing3: 72,
  spacing4: 80,
  spacing5: 88,
  spacing6: 96
};

const extraLarge = {
  spacing1: 104,
  spacing2: 112
};

export default {
  small,
  medium,
  large,
  extraLarge
};
